import { ExternalLinkInput } from 'schema'

export interface ExternalLinkEditorProps {
  /**
   * quick link options
   */
  quickLinkOptions?: {
    /**
     * whether the quick links button should be loading
     */
    loading?: boolean
    /**
     * quick links to make available in the quick link button
     *
     * only rendered if there are quick links
     *
     * @see {@link QuickLink}
     */
    quickLinks: QuickLink[] | undefined
  }
  /**
   * whether to disable all controls
   */
  disabled?: boolean
  /**
   * messages to add above the buttons and form list
   */
  messages?: {
    /**
     * @see {@link ExternalLinkEditorMessage.SharePoint}
     */
    sharePoint?: true
    /**
     * @see {@link ExternalLinkEditorMessage.EditPackageNumberName}
     */
    editPackageNumberName?: true
    /**
     * any custom messages you want to add after the default messages
     */
    custom?: string | string[]
  }
}

interface QuickLink {
  id: string
  label: string
  href?: string | null
  description?: string | null
}

export const ExternalLinkEditorMessage = {
  SharePoint: 'SharePoint Folder external links are managed by CIMS',
  EditPackageNumberName:
    'Edit the Package Number or Package Name to edit the SharePoint Folder link',
} as const

export interface ExternalLinkEditorValues {
  externalLinks?: ExternalLinkInput[]
}
